import React from "react";
import { useTheme } from "@/components/theme-provider";

interface LogoProps {
  className?: string;
  alt?: string;
  collapsed?: boolean;
  onClick?: () => void;
}

export const Logo: React.FC<LogoProps> = ({
  className = "h-7 w-auto max-w-[140px]",
  alt = "ForgeCode Logo",
  collapsed = false,
  onClick,
}) => {
  const { theme } = useTheme();

  // Determine which logo to use based on current theme and collapsed state
  const getLogoSrc = () => {
    const baseUrl = import.meta.env.BASE_URL || "/";

    if (collapsed) {
      // Use small logos for collapsed state
      if (theme === "dark") {
        return `${baseUrl}logo-small-light.png`; // Use light small logo for dark theme
      } else {
        return `${baseUrl}logo-small-dark.png`; // Use dark small logo for light theme
      }
    } else {
      // Use regular logos for expanded state
      if (theme === "dark") {
        return `${baseUrl}logo-light.svg`; // Use light logo for dark theme
      } else {
        return `${baseUrl}logo-dark.svg`; // Use dark logo for light theme
      }
    }
  };

  return (
    <img
      src={getLogoSrc()}
      alt={alt}
      className={`${className} ${onClick ? "cursor-pointer hover:opacity-80 transition-opacity" : ""}`}
      onClick={onClick}
    />
  );
};
